<script>
  import {BizHeader, bizBreakpoint} from "@util/constant.js"
  import ToggleButton from "@components/ToggleButton.svelte";
  import InformationTicker from "@modules/InformationTicker.svelte";
  const logo_mng = "/assets_default/icons/logo.svg"
  import { onMount } from 'svelte';
  let MenuToggle = $state(false);
  let isMobile = $state(false);

  function buttonToggle () {
    MenuToggle = !MenuToggle
  }
  let logoOnry = $state(false);

  function mobileNavClick () {
    if(isMobile && MenuToggle){
      buttonToggle();
    }
  }
  onMount(() => {
    const path = window.location.pathname;
    // パスに /business/ が含まれ、かつトップページ（/business/ または /business/index.html で終わる）ではない場合に true
    if (path.includes('/business/') && !path.endsWith('/business/') && !path.endsWith('/business/index.html')) {
      logoOnry = true;
    }

    const checkWidth = () => {
      isMobile = window.innerWidth <= bizBreakpoint;
    };
    // 初期表示時に幅をチェック
    checkWidth();
    // ウィンドウサイズが変更されたときに幅をチェック
    window.addEventListener('resize', checkWidth);
    // コンポーネントが破棄されるときにイベントリスナーを削除
    return () => {
      window.removeEventListener('resize', checkWidth);
    };
  });
</script>

<InformationTicker/>
<header class="owd-biz-header" id="owd-biz-header">
  <div class="header-section">
    <div class="header-logo-wrap">
      <a href="/">
        <img class="mng-logo" src="{logo_mng}" width="190" height="30" alt="Minna no Ginko">
      </a>
      {#if !logoOnry && isMobile}
      <ToggleButton {MenuToggle} clickEvent={buttonToggle} />
      {/if}
    </div>
    {#if !logoOnry}
    <!-- {#if !logoOnry && (!isMobile || (isMobile && MenuToggle))} -->
    <nav class:is-open={isMobile && MenuToggle}>
      <ul class="header-nav:l">
        {#each BizHeader as nav}
          <li class="owd-text:02"><a href="{nav.href}" on:click={mobileNavClick}><strong>{nav.label}</strong></a></li>
        {/each}
      </ul>
      <ul class="header-nav:r">
        <li class="owd-text:02"><a href="/"><strong>個人のお客さま</strong></a></li>
        <ul>
          <li>
            <a href="/business/open-account/notes/" class="owd-button owd-button:primary owd-button:small" id="pc-header-business">
              法人口座を開設する
            </a>
          </li>
          <li>
            <a href="https://eib.minna-no-ginko.com/" target="_blank" class="owd-button owd-button:secondary:white owd-button:small" id="pc-header-business">
              法人インターネットバンキングログイン
            </a>
          </li>
        </ul>
      </ul>
    </nav>
    {/if}
  </div>
</header>

<style lang="scss">


.owd-biz-header{
  width: 100%;
  background-color:var(--primary-white);
  padding: 32px 40px;
  a{
    text-decoration: none;
  }
  .header{
    &-section{
      width: 100%;
      // display: grid;
      // grid-template-columns: 190px 1fr;
      // gap: 48px;

      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    &-logo-wrap{
      max-width: 190px;
      margin-right: 48px;
    }
    &-menu-button{
      display: none;
    }
  }
  nav{
    display: contents;
    ul{
      display: flex;
      align-items: center;
      li{
        a{
          @include g.hover-text-decoration($color: var(--primary-black),$type: solid,$size: 2px,$offset: 6px);
        }
      }
    }
    .header-nav{
      &\:l{
        gap: 24px;
      }
      &\:r{
        gap: 16px;
        margin-left: auto;
        >ul{
          display: grid;
          align-items: center;
          gap: 8px;
          grid-template-columns:150px 260px;
          // grid-template-columns: 172px 289px;
          .owd-button{
            padding: 16px;
            height: 45px;
            text-decoration: none;
            letter-spacing: 0.07px;
          }
          .owd-button\:secondary\:white{
            max-width: none;
          }
        }
      }
    }
  }
  @media (max-width: 1405px) {
  // @media (max-width: 1280px) {
    .header{
      &-logo-wrap{
        margin-right: 20px;
      }
    }
    nav{
      .header-nav{
        &\:l{
          order: 1;
          width: 100%;
          padding-top: 16px;
        }
      }
    }
  }
  @include g.mobile {
    padding: 0px;
    position: relative;
    .header{
      &-section{
        display: block;
      }
      &-logo-wrap{
        display: grid;
        align-items: center;
        justify-content: space-between;
        grid-template-columns: 190px 26px;
        min-height: 56px;
        position: relative;
        z-index: 99;
        padding: 0px 24px;
        max-width: none;
        margin-right: 0;
        background-color: white;
      }
    }
    nav{
      display: flex;
      width: 100%;
      background-color: var(--primary-white);
      flex-direction: column;
      align-items: flex-start;
      position: absolute;
      bottom: 0;
      z-index: 10;
      padding: 40px 24px;
      transform: translateY(0);
      // opacity: 0;
      transition: .5s ease-in-out;
      &.is-open{
        transform: translateY(100%);
        // opacity: 1;
      }
      ul{
        align-items: flex-start;
        flex-direction: column;
      }
      .header-nav{
        &\:l{
          gap: 40px;
          margin-bottom: 40px;
          order: initial;
        }
        &\:r{
          margin-left: 0;
          >ul{
            display: none;
          }
        }
      }
    }
  }
}
</style>
